<h2>Search</h2>

<mat-card class="search">

  <mat-form-field>
    <mat-label>Find Users</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex: Mia" #input>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" matSort>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- TODO hide in prod: -->
    <ng-container matColumnDef="id" class="id-column">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
      <td mat-cell *matCellDef="let row"> {{row.id}} </td>
    </ng-container>

    <ng-container matColumnDef="img" class="img-column">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Img </th>
      <td mat-cell *matCellDef="let row">
        <img mat-card-avatar [src]="row.img" alt="Image of {{row.username}}" class="profile-img">
      </td>
    </ng-container>

    <ng-container matColumnDef="username" class="username-column">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Username </th>
      <td mat-cell *matCellDef="let row"> {{row.username}} </td>
    </ng-container>

    <ng-container matColumnDef="bio" class="bio-column">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Bio </th>
      <td mat-cell *matCellDef="let row"> {{row.bio}} </td>
    </ng-container>

    <ng-container matColumnDef="buttons" class="buttons-column">
      <th mat-header-cell *matHeaderCellDef> Action </th>
      <td mat-cell *matCellDef="let row">
        <a mat-raised-button color="primary" routerLink="" routerLinkActive="active" ariaCurrentWhenActive="page"
          routerLink="/profile/{{row.id}}">
          Go to profile
        </a>
      </td>
    </ng-container>


    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No users matching the "{{input.value}}"</td>
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  
</mat-card>